import { useEffect, useState } from 'react';

type CompactLayoutState = {
  isCompactLayout: boolean;
  forceCoverMedia: boolean;
  isPortrait: boolean;
};

export const useCompactLayout = (): CompactLayoutState => {
  const [useCompactLayoutState, setUseCompactLayoutState] = useState(false);
  const [forceCoverMedia, setForceCoverMedia] = useState(false);
  const [isPortrait, setIsPortrait] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const widthQuery = window.matchMedia('(max-width: 767px)');
    const heightQuery = window.matchMedia('(max-height: 520px)');
    const orientationQuery = window.matchMedia('(orientation: landscape)');
    const portraitQuery = window.matchMedia('(orientation: portrait)');
    const updateLayout = () => {
      setUseCompactLayoutState(widthQuery.matches || heightQuery.matches);
      setForceCoverMedia(orientationQuery.matches);
      setIsPortrait(portraitQuery.matches);
    };
    updateLayout();
    if (widthQuery.addEventListener) {
      widthQuery.addEventListener('change', updateLayout);
      heightQuery.addEventListener('change', updateLayout);
      orientationQuery.addEventListener('change', updateLayout);
      portraitQuery.addEventListener('change', updateLayout);
      return () => {
        widthQuery.removeEventListener('change', updateLayout);
        heightQuery.removeEventListener('change', updateLayout);
        orientationQuery.removeEventListener('change', updateLayout);
        portraitQuery.removeEventListener('change', updateLayout);
      };
    }
    widthQuery.addListener(updateLayout);
    heightQuery.addListener(updateLayout);
    orientationQuery.addListener(updateLayout);
    portraitQuery.addListener(updateLayout);
    return () => {
      widthQuery.removeListener(updateLayout);
      heightQuery.removeListener(updateLayout);
      orientationQuery.removeListener(updateLayout);
      portraitQuery.removeListener(updateLayout);
    };
  }, []);

  return {
    isCompactLayout: useCompactLayoutState,
    forceCoverMedia,
    isPortrait,
  };
};
